import React, { useEffect, useState, useSyncExternalStore } from 'react';
import { useFloorPlanCompare } from '../../../hooks/useFloorPlanCompare';
import FloorPlanCompareFab from './FloorPlanCompareFab';
import FloorPlanCompareModal from './FloorPlanCompareModal';
import { logPublicFloorPlanComparisonOpened } from '../../../services/analytics';
import { getShareExpiry, subscribeShareExpiry } from '../../../services/shareContext';

/**
 * App-level compare FAB + modal. Mounted once at the public SPA root so
 * the cart stays visible when navigating between `SitePlansPage`, project
 * detail, and project research — mirrors the agent FAB in
 * `SuperPickerApp.tsx` (~line 28802).
 */
export const FloorPlanCompareShell: React.FC = () => {
  const { cart, compareOpen, openCompare, closeCompare, remove, move, clear } =
    useFloorPlanCompare();
  const expiresAt = useSyncExternalStore(subscribeShareExpiry, getShareExpiry, () => null);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (expiresAt == null) return;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [expiresAt]);

  const trialActive = expiresAt == null || now < expiresAt;

  useEffect(() => {
    if (!trialActive && compareOpen) closeCompare();
  }, [trialActive, compareOpen, closeCompare]);

  if (!trialActive) return null;

  return (
    <>
      <FloorPlanCompareFab
        count={cart.length}
        onClick={() => {
          logPublicFloorPlanComparisonOpened({ source: 'compare_fab' });
          openCompare();
        }}
      />
      <FloorPlanCompareModal
        open={compareOpen}
        cart={cart}
        onClose={closeCompare}
        onRemove={remove}
        onMove={move}
        onClear={clear}
      />
    </>
  );
};

export default FloorPlanCompareShell;
